import { render, staticRenderFns } from "./comPush.vue?vue&type=template&id=123696ec&"
import script from "./comPush.vue?vue&type=script&lang=js&"
export * from "./comPush.vue?vue&type=script&lang=js&"
import style0 from "./comPush.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports